import { OfferingResults } from '@de/components/OfferingResults';
import ResultsPage from '../ResultsPage';
import { ResultType, Step, StepResult } from '@de/types';
import ConfigurableStep from '@de/components/Step/variants/ConfigurableStep';

type ResultsProps = Step & StepResult;

export function Results(props: ResultsProps) {
  // DSL-backed RESULT steps short-circuit the resultType dispatch and render
  // through the configurable bridge so data sources, actions, and tracking
  // context match the rest of the DSL runtime.
  if (props.dslConfigId) {
    if (props.resultType) {
      console.warn(
        `[Results] Step "${props.id ?? 'unknown'}" has both resultType "${props.resultType}" and dslConfigId "${props.dslConfigId}"; routing through DSL. Payloads should declare exactly one.`,
      );
    }
    return (
      <ConfigurableStep
        key={props.dslConfigId ?? props.id ?? 'configurable-result'}
        dslConfig={props.dslConfig}
        flowType={props.flowType}
        trafficSource={props.trafficSource}
      />
    );
  }

  switch (props.resultType) {
    case ResultType.CUSTOM_RESULTS_PAGE:
      return <h1>Custom Results Page</h1>;
    case ResultType.OFFERINGS:
      return <OfferingResults />;
    default:
      return (
        <ResultsPage
          variant={props.variant}
          title={props.title}
          subtitle={props.subtitle}
        />
      );
  }
}
